import { Box, Card, Collapse, Divider, IconButton, Stack, Typography } from '@mui/material';
import React, { useState } from 'react';

import { ChevronDownIcon } from '@/assets/icons/ChevronDownIcon';
import { ChevronUpIcon } from '@/assets/icons/ChevronUpIcon';

interface HowWeRankVendorsProps {
  initialExpanded?: boolean;
}

const HowWeRankVendors: React.FC<HowWeRankVendorsProps> = ({ initialExpanded = false }) => {
  const [showRankingInfo, setShowRankingInfo] = useState(initialExpanded);

  return (
    <Card sx={{ backgroundColor: 'grey.50', border: '1px solid', borderColor: 'grey.200' }}>
      <Box
        sx={{
          p: 2,
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          '&:hover': {
            backgroundColor: 'grey.100',
          },
        }}
        onClick={() => setShowRankingInfo(!showRankingInfo)}
      >
        <Typography variant="h6" sx={{ fontWeight: 600, textAlign: 'center', width: '100%' }}>
          How We Rank Providers
        </Typography>
        <IconButton size="small">
          {showRankingInfo ? (
            <ChevronUpIcon width={20} height={20} />
          ) : (
            <ChevronDownIcon width={20} height={20} />
          )}
        </IconButton>
      </Box>
      <Collapse in={showRankingInfo}>
        <Divider />
        <Box sx={{ p: 3, pt: 2 }}>
          <Stack spacing={2}>
            <Typography variant="body2" color="text.secondary">
              Each provider gets a match score from 0 to 100% based on how well they fit your needs:
            </Typography>
            <Stack spacing={1.5}>
              <Typography variant="body2" sx={{ fontWeight: 500 }}>
                What makes a provider score higher:
              </Typography>
              <Stack spacing={1} sx={{ ml: 2 }}>
                <Stack direction="row" spacing={1} alignItems="flex-start">
                  <Typography variant="body2">🏆</Typography>
                  <Typography variant="body2" color="text.secondary">
                    <strong>Great Reviews</strong> - Providers with 4.5+ stars and lots of happy
                    customers
                  </Typography>
                </Stack>
                <Stack direction="row" spacing={1} alignItems="flex-start">
                  <Typography variant="body2">📍</Typography>
                  <Typography variant="body2" color="text.secondary">
                    <strong>Close to You</strong> - The closer they are, the better they score
                  </Typography>
                </Stack>
                <Stack direction="row" spacing={1} alignItems="flex-start">
                  <Typography variant="body2">⚡</Typography>
                  <Typography variant="body2" color="text.secondary">
                    <strong>Available Now</strong> - For urgent needs, providers available 24/7 or
                    same-day get priority
                  </Typography>
                </Stack>
                <Stack direction="row" spacing={1} alignItems="flex-start">
                  <Typography variant="body2">✅</Typography>
                  <Typography variant="body2" color="text.secondary">
                    <strong>Fully Licensed</strong> - Properly licensed, insured, and certified
                    professionals
                  </Typography>
                </Stack>
                <Stack direction="row" spacing={1} alignItems="flex-start">
                  <Typography variant="body2">🎯</Typography>
                  <Typography variant="body2" color="text.secondary">
                    <strong>Perfect Match</strong> - Specialists in exactly what you need (not just
                    "general services")
                  </Typography>
                </Stack>
                <Stack direction="row" spacing={1} alignItems="flex-start">
                  <Typography variant="body2">⭐</Typography>
                  <Typography variant="body2" color="text.secondary">
                    <strong>Top Rated</strong> - Award-winning or highly recommended by the
                    community
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
          </Stack>
        </Box>
      </Collapse>
    </Card>
  );
};

export default HowWeRankVendors;
